import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/DraftCreatePage_selection.css";

const draftTypes = [
  { value: "court", label: "Honorable Court" },
  { value: "police", label: "Police Station Complaint" },
  { value: "department", label: "Department" },
  { value: "application", label: "General Application/Petition" },
  { value: "consumer", label: "Consumer Complaint" },
  { value: "legal-notice", label: "Legal Notice" },
  { value: "agreement", label: "Agreement/Contract" },
  { value: "bail", label: "Bail Application" },
  { value: "affidavit", label: "Affidavit" },
  { value: "will", label: "Will/Testament" },
  { value: "property", label: "Property Documents" },
];

const DraftCreatePage = () => {
  const navigate = useNavigate();

  const handleDraftTypeSelection = (draftType) => {
    // Navigate to the selected form page
    if (draftType === "court") {
      navigate("/forms/court");
    } else if (draftType === "police") {
      navigate("/forms/police");
    } else if (draftType === "department") {
      navigate("/forms/department");
    } else if (draftType === "bail") {
      navigate("/forms/bail");
    } else if (draftType === "consumer") {
      navigate("/forms/consumer");
    } else if (draftType === "legal-notice") {
      navigate("/forms/legal-notice");
    } else if (draftType === "agreement") {
      navigate("/forms/agreement");
    } else if (draftType === "application") {
      navigate("/forms/application");
    } else if (draftType === "affidavit") {
      navigate("/forms/affidavit");
    } else if (draftType === "will") {
      navigate("/forms/will");
    } else if (draftType === "property") {
      navigate("/forms/property");
    }
  };

  return (
    <div className="draft-create-page">
      <div className="draft-header">
        <h1>Create Legal Draft</h1>
        <p>Select the type of legal document you want to create</p>
      </div>

      <div className="draft-type-grid">
        {Array.from(new Map(draftTypes.map((t) => [t.value, t])).values()).map((type) => (
          <div
            key={`${type.value}-${type.label}`}
            className="draft-type-card"
            onClick={() => handleDraftTypeSelection(type.value)}
          >
            <div className="draft-type-icon">
              📄
            </div>
            <h3>{type.label}</h3>
            <p>Create a professional draft for {type.label.toLowerCase()}</p>
            <button className="select-draft-btn">
              {/* Create {type.label} */}
              Click to Create
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DraftCreatePage;
